import { defineStore } from 'pinia';
import Cycle from 'src/boot/services/Cycle';
import StudyControl from 'src/boot/services/StudyControl';
import { CycleData, DailySubjects, DaysOfWeekKeys, Study } from 'src/types';
import { useEvaluations } from './useEvaluations';

export const useStudyControls = defineStore('study-control', {
  state: () => ({
    study: undefined as Study | undefined,
    cycle: undefined as CycleData | undefined,
    dailySuggestedSubjects: undefined as DailySubjects[] | undefined,
  }),
  getters: {},
  actions: {
    async fetchStudy() {
      const response = await StudyControl.fetchCurrentStudy();
      if (!response || !response?.data?._items?.length) {
        this.study = undefined;
        return;
      }
      this.study = response.data._items[0];
    },
    async fetchCycles() {
      if (!this.study?._id) return;
      const response = await Cycle.fetchCycles(this.study._id);
      if (!response?.data?._items?.length) {
        this.cycle = undefined;
        return;
      }
      this.cycle = response.data._items[0];
      if(this.cycle.subjects.length) {
        const useEvaluation = useEvaluations();
        const suggestedSubjects = this.cycle.subjects.map(el => el.subject);
        await useEvaluation.updateSuggestedSubjects(suggestedSubjects);
      }
    },
    async fetchDailySuggestedSubjects(todayOfWeek: DaysOfWeekKeys) {
      if (this.cycle?._id) {
        try {
          const response = await Cycle.fetchDailySubjectsSuggestions({
            id: this.cycle._id,
            day: todayOfWeek,
          });
          this.dailySuggestedSubjects = response?.data || undefined;
        } catch (error) {
          console.error(error);
        }
      }
    },
  },
});
